import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledSwitchProfileIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M2.961 19.9424C3.9003 16.9254 5.90733 14.3755 8.09376 13.5031L15.9064 13.5014C18.0692 14.3641 20.0927 16.9197 21.0397 19.9396C21.279 20.7027 20.6703 21.5003 19.7361 21.5005L4.26723 21.504C3.33328 21.5042 2.72299 20.7068 2.961 19.9424Z",
			fill: "#33BF8D",
			stroke: "#008355",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "path-2-outside-1_3864_10735",
			maskUnits: "userSpaceOnUse",
			x: 7.99978,
			y: 10.2492,
			width: 8.00135,
			height: 6.0018,
			fill: "black",
			children: [/* @__PURE__ */ _jsx("rect", {
				fill: "white",
				x: 7.99978,
				y: 10.2492,
				width: 8.00135,
				height: 6.0018
			}), /* @__PURE__ */ _jsx("path", { d: "M15 11.2494L15.0004 13.2494C15.0007 14.354 14.1055 15.2496 13.0009 15.2498L11.0009 15.2503C9.89633 15.2505 9.0007 14.3553 9.00045 13.2507L9 11.2507" })]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 11.2494L15.0004 13.2494C15.0007 14.354 14.1055 15.2496 13.0009 15.2498L11.0009 15.2503C9.89633 15.2505 9.0007 14.3553 9.00045 13.2507L9 11.2507",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 11.2492C15.9999 10.6969 15.5521 10.2493 14.9998 10.2494C14.4475 10.2495 13.9999 10.6973 14 11.2496L16 11.2492ZM10 11.2505C9.99988 10.6982 9.55206 10.2506 8.99978 10.2507C8.44749 10.2509 7.99988 10.6987 8 11.251L10 11.2505ZM10.0004 13.2505L10 11.2505L8 11.251L8.00045 13.251L10.0004 13.2505ZM13.0007 14.2498L11.0007 14.2503L11.0011 16.2503L13.0011 16.2498L13.0007 14.2498ZM14 11.2496L14.0004 13.2496L16.0004 13.2492L16 11.2492L14 11.2496ZM8.00045 13.251C8.00082 14.9078 9.34427 16.2507 11.0011 16.2503L11.0007 14.2503C10.4484 14.2504 10.0006 13.8028 10.0004 13.2505L8.00045 13.251ZM13.0011 16.2498C14.658 16.2495 16.0008 14.906 16.0004 13.2492L14.0004 13.2496C14.0006 13.8019 13.553 14.2497 13.0007 14.2498L13.0011 16.2498Z",
			fill: "#008355",
			mask: "url(#path-2-outside-1_3864_10735)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5 8C17.5 11.0376 15.0376 13.5 12 13.5C8.96243 13.5 6.5 11.0376 6.5 8C6.5 4.96243 8.96243 2.5 12 2.5C15.0376 2.5 17.5 4.96243 17.5 8Z",
			fill: "white",
			stroke: "#008355"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 12.5H16C15.1716 12.5 14.5 13.1716 14.5 14V22C14.5 22.8284 15.1716 23.5 16 23.5H22C22.8284 23.5 23.5 22.8284 23.5 22V14C23.5 13.1716 22.8284 12.5 22 12.5Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22 13C22.2652 13 22.5196 13.1054 22.7071 13.2929C22.8946 13.4804 23 13.7348 23 14V22C23 22.2652 22.8946 22.5196 22.7071 22.7071C22.5196 22.8946 22.2652 23 22 23H16C15.7348 23 15.4804 22.8946 15.2929 22.7071C15.1054 22.5196 15 22.2652 15 22V14C15 13.7348 15.1054 13.4804 15.2929 13.2929C15.4804 13.1054 15.7348 13 16 13H22ZM22 12H16C15.4696 12 14.9609 12.2107 14.5858 12.5858C14.2107 12.9609 14 13.4696 14 14V22C14 22.5304 14.2107 23.0391 14.5858 23.4142C14.9609 23.7893 15.4696 24 16 24H22C22.5304 24 23.0391 23.7893 23.4142 23.4142C23.7893 23.0391 24 22.5304 24 22V14C24 13.4696 23.7893 12.9609 23.4142 12.5858C23.0391 12.2107 22.5304 12 22 12ZM21.84 15.13L20.1 13.4C20.0072 13.3072 19.8813 13.255 19.75 13.255C19.6187 13.255 19.4928 13.3072 19.4 13.4C19.3072 13.4928 19.255 13.6187 19.255 13.75C19.255 13.8813 19.3072 14.0071 19.4 14.1L20.29 15H16.5C16.3674 15 16.2402 15.0527 16.1464 15.1464C16.0527 15.2402 16 15.3674 16 15.5C16 15.6326 16.0527 15.7598 16.1464 15.8535C16.2402 15.9473 16.3674 16 16.5 16H20.29L19.4 16.9C19.3072 16.9928 19.255 17.1187 19.255 17.25C19.255 17.3813 19.3072 17.5071 19.4 17.6C19.4928 17.6928 19.6187 17.7449 19.75 17.7449C19.8813 17.7449 20.0072 17.6928 20.1 17.6L21.84 15.87C21.8906 15.8247 21.9311 15.7692 21.9586 15.7071C21.9862 15.6451 22.0003 15.5779 22 15.51C22.0032 15.4387 21.9906 15.3677 21.9629 15.3019C21.9352 15.2362 21.8932 15.1774 21.84 15.13ZM17.71 20H21.5V19.98C21.6326 19.98 21.7598 20.0327 21.8536 20.1264C21.9473 20.2202 22 20.3474 22 20.48C22 20.6126 21.9473 20.7398 21.8536 20.8335C21.7598 20.9273 21.6326 20.98 21.5 20.98H17.71L18.6 21.88C18.6928 21.9728 18.745 22.0987 18.745 22.23C18.745 22.3613 18.6928 22.4872 18.6 22.58C18.5072 22.6728 18.3813 22.725 18.25 22.725C18.1187 22.725 17.9928 22.6728 17.9 22.58L16.16 20.85C16.1094 20.8047 16.069 20.7492 16.0414 20.6871C16.0138 20.6251 15.9997 20.5579 16 20.49C15.9997 20.4221 16.0138 20.3549 16.0414 20.2928C16.069 20.2308 16.1094 20.1752 16.16 20.13L17.9 18.4C17.9928 18.3072 18.1187 18.255 18.25 18.255C18.3813 18.255 18.5072 18.3072 18.6 18.4C18.6928 18.4928 18.745 18.6187 18.745 18.75C18.745 18.8813 18.6928 19.0071 18.6 19.1L17.71 20Z",
			fill: "#008355"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledSwitchProfileIcon);
const Memo = memo(ForwardRef);
export default Memo;
